import { AuthError } from "@/enums/errorMessages";
import { AxiosError } from "axios";

// Define types for expected error responses
type ApiErrorResponse = {
  error?: string | string[];
  message?: string;
};

export const ErrorHelper = (error: unknown): string | string[] => {
  // 1. Handle Axios errors
  if (isAxiosError(error) && error.response?.data) {
    const errorData = error.response.data as ApiErrorResponse;

    // Handle array errors format: {"error":{"errors":["msg1", "msg2"]}}
    if (errorData.error && Array.isArray(errorData.error)) {
      return errorData.error.length > 1 ? errorData.error : errorData.error[0];
    }

    // Handle simple error format: {"error":"message"}
    if (typeof errorData.error === "string") {
      return errorData.error;
    }

    // Handle message format: {"message":"..."}
    if (errorData.message) {
      return errorData.message;
    }

    // Fallback to stringify if error exists but format is unexpected
    if (errorData.error) {
      return JSON.stringify(errorData.error);
    }
  }

  //  Handle Error instances
  if (error instanceof Error) return error.message;

  //  Handle string errors
  if (typeof error === "string") return error;

  //  Final fallback
  return AuthError.UNKNOWN_ERROR;
};

// Type guard for Axios errors
const isAxiosError = (error: unknown): error is AxiosError => {
  if (typeof error !== "object" || error === null) return false;

  const err = error as Record<string, unknown>;
  return err["isAxiosError"] === true || err["__isAxiosError"] === true;
};
